// The signed-in person's own name, as the screens show it.
//
// The name comes from whoami's display_name: the person's People record
// full name, else a stored real name (never an email). The Static Web
// Apps login is only a fallback, for a person with neither, because a
// login reads as "rkellan@..." and its local part is not a name.
//
// This file and the type in types.ts are the only places in src/ that
// read the login; tools/lint-principal-user-details.sh holds that line.

import type { ClientPrincipal, WhoamiResponse } from './types';

/** The name for the user menu, the greeting and a submitter. Empty while
 *  whoami is loading, so the login never flashes before the name lands. */
export function signedInName(
  whoami: Pick<WhoamiResponse, 'display_name'> | null | undefined,
  principal: Pick<ClientPrincipal, 'userDetails'> | null | undefined,
): string {
  if (!whoami) return '';
  const stored = whoami.display_name?.trim() ?? '';
  if (stored && !stored.includes('@')) return stored;
  return principal?.userDetails?.trim() ?? '';
}

/** The first word of a name: "Rowan Kellan" reads as "Rowan". A login
 *  is not a name, so an email-shaped word gives nothing (the greeting
 *  then reads without one). */
export function firstWord(name: string): string {
  const word = name.trim().split(/\s+/)[0] ?? '';
  return word.includes('@') ? '' : word;
}

/** The login, for a visitor with no account here: there is no whoami
 *  name to show, and the landing tells them which login they used. */
export function loginForUnprovisioned(
  principal: Pick<ClientPrincipal, 'userDetails'> | null | undefined,
): string | null {
  return principal?.userDetails ?? null;
}
